import PropTypes from "prop-types"
import React, { createContext } from "react"
import { useMarina } from "src/contexts/MarinaContext"

import {
  getProductsTable,
  getProductsTableIds,
} from "src/api/Manage/ProductsTable"

import usePOSAccess, {
  marinaAccessProps,
} from "src/hooks/module_gate_hooks/use_pos_access"
import useDatatable from "src/hooks/use_datatable"
import useWindowSize from "src/hooks/use_window_size"

import CategorySidebar from "./CategorySidebar"
import ManageItemsTable from "./ManageItemsTable"
import useCategories from "./hooks/use_categories"

export const ManageItemsContext = createContext(null)

export const DEFAULT_FILTERS = {
  search: "",
  status: "active",
  productCategories: [],
  missingBarcode: false,
  inventoryOnly: false,
}

const ManageItemsContainer = ({
  canManageItems,
  canAdjustQuantitiesViaImport,
  marinaAccess,
  useNewTaxExperience,
  accountingV2Enabled,
  currentUserId,
}) => {
  const { width: windowWidth } = useWindowSize()
  const { marinaSlug } = useMarina()
  const { access } = usePOSAccess({ marinaSlug, initialData: marinaAccess })
  const { categories, setCategories, categoriesLoading, categoriesError } =
    useCategories({ marinaSlug })

  const table = useDatatable({
    queryKey: ["manageItems", marinaSlug],
    fetchFn: getProductsTable,
    defaultFilters: DEFAULT_FILTERS,
    fetchAllIds: (params) => getProductsTableIds(params).then((r) => r.ids),
  })

  const value = {
    marinaSlug,
    canManageItems,
    canAdjustQuantitiesViaImport,
    categories,
    categoriesError,
    categoriesLoading,
    setCategories,
    table,
    marinaAccess: access,
    useNewTaxExperience,
    accountingV2Enabled,
    currentUserId,
  }

  return (
    <ManageItemsContext.Provider value={value}>
      <div className="mt-4 flex flex-col manage-items-md:mt-8 manage-items-md:flex-row">
        <div className="manage-items-md:border-grey-300 min-w-[250px] p-4 pb-0 pl-8 manage-items-md:h-[90vh] manage-items-md:border-r">
          <CategorySidebar collapseCategories={windowWidth <= 1025} />{" "}
          {/* this 1025 value must be kept in sync with manage-items-md in the tailwind config */}
        </div>
        <div className="w-full min-w-0 p-4 pb-8 pl-8">
          <ManageItemsTable />
        </div>
      </div>
    </ManageItemsContext.Provider>
  )
}

ManageItemsContainer.propTypes = {
  canManageItems: PropTypes.bool.isRequired,
  canAdjustQuantitiesViaImport: PropTypes.bool,
  marinaAccess: PropTypes.shape(marinaAccessProps).isRequired,
  useNewTaxExperience: PropTypes.bool,
  accountingV2Enabled: PropTypes.bool,
  currentUserId: PropTypes.string,
}

export default ManageItemsContainer
